import { owaDate } from 'owa-datetime';

export default function hasUserPolicyStoreExpired(userOcpsPoliciesExpiration: string): boolean {
    return (
        !userOcpsPoliciesExpiration ||
        owaDate('UTC') > owaDate('UTC', new Date(userOcpsPoliciesExpiration).toISOString())
    );
}
